<template>
    <div class="mission mainBody">
        <div class="input_area">
            <div class="input_box">
                <div class="box_top">
                    <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.lable}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="groupList.item2.selectOrinput" class="input_label" for="select">{{groupList.item2.lable}}</label>
                        <el-select v-if="groupList.item2.selectOrinput" id="select" class="inputInner" v-model="groupList.item2.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item2.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input_group" v-if="groupList.item4.isShow">
                        <div class="buttonBox">
                            <button class="formButton add_btn" @click='editFile'>编辑/选择</button>
                        </div>
                            
                    </div>
                </div>
                <div class="box_bottom" v-if="boxBottom.isBoxBottom">
                        <label class="input_label" for="beizhu">{{boxBottom.label}}</label>
                        <el-input id="beizhu" v-model="boxBottom.input" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="add_box">
                <button class="formButton add_btn"  @click="submit" >发送</button>
            </div>
        </div>
        <div class="table_area">
                <el-table
                :stripe='true'
                        :data="tableData"
                        height="100%"
                        style="width: 100%;">
                        <el-table-column
                            prop="engineerregion_id"
                            label="所属工区"
                            width="180"
                            align="center">
                            <template slot-scope="scope">
                                <!-- <input class="innerInput" type="text" v-model="tableData[scope.$index].materialtype_id"> -->
                                <el-select disabled="disabled" id="select" class="innerInput" v-model="tableData[scope.$index].engineerregion_id" placeholder="请选择">
                                    <el-option
                                    v-for="item in groupList.item1.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="boat_id"
                            label="船舶"
                            align="center">
                            <template slot-scope="scope">
                                <!-- <input class="innerInput" type="text" v-model="tableData[scope.$index].materialtype_id"> -->
                                <el-select disabled="disabled" id="select" class="innerInput" v-model="tableData[scope.$index].boat_id" placeholder="请选择">
                                    <el-option
                                    v-for="item in groupList.item2.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="axis_id"
                            label="轴线"
                            align="center">
                            <template slot-scope="scope">
                                <!-- <input class="innerInput" type="text" v-model="tableData[scope.$index].materialtype_id"> -->
                                <el-select disabled="disabled" id="select" class="innerInput" v-model="tableData[scope.$index].axis_id" placeholder="请选择">
                                    <el-option
                                    v-for="item in groupList.item3.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="projectfile_id"
                            label="工程文件"
                            align="center">
                            <template slot-scope="scope">
                                <!-- <input class="innerInput" type="text" v-model="tableData[scope.$index].materialtype_id"> -->
                                <el-select disabled="disabled" id="select" class="innerInput" v-model="tableData[scope.$index].projectfile_id" placeholder="请选择">
                                    <el-option
                                    v-for="item in groupList.item4.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            prop="sendtime"
                            label="发送时间"
                            width="200px"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="recivestate"
                            label="接收状态"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="completion_status"
                            label="完成状态"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="option"
                            label="操作"
                            align="center">
                            <template slot-scope="scope">
                                <!-- <button
                                class="tablebtn_inner btnView"
                                @click="openAmend(scope.$index,scope.row)">修改</button> -->
                                <button class="tablebtn_inner btnDelet" @click="openDelete(scope.$index,scope.row,1)">删除</button>
                            </template>
                        </el-table-column>
                </el-table>
        </div>
        <div class="innerPoper" v-if="innerPoper1">
            <div class="form_head">
                <div class="detail">{{activeName}}</div>
                <button @click="closePoper2" class="formButton exit">退出</button>
            </div>
            <el-tabs @tab-click='closePoper3' class="innnerTabs"  v-model="activeName">
                <el-tab-pane class="innnerTab" label="工程文件" name="工程文件">
                    <el-table
                        :stripe='true'
                        ref='multipleTable'
                        :data="tableData_proj"
                        height="100%"
                        style="width: 100%;">
                        <el-table-column label="选择" align="center" width="100px">
                            <template scope="scope">
                            <el-radio :label="scope.$index" v-model="radio"
                                        @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="project_name"
                            label="工程文件"
                            align="center">
                            <template slot-scope="scope">
                                <el-input disabled="disabled" class="innerInput" type="text" v-model="tableData_proj[scope.$index].project_name"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="axis_id"
                            label="对应轴线"
                            align="center">
                            <template slot-scope="scope">
                                <el-select disabled="disabled" id="select" class="inputInner" v-model="tableData_proj[scope.$index].axis_id" placeholder="请选择" >
                                    <el-option
                                    v-for="item in groupList.item3.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="updatetime"
                            label="更新时间"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="endTime"
                            label="发送状态"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="option"
                            align="center"
                            label="操作">
                            <template slot-scope="scope">
                                <!-- <button
                                class="tablebtn_inner btnView"
                                @click="openAmend(scope.$index,scope.row,3)">修改</button> -->
                                <button
                                class="tablebtn_inner btnView"
                                @click="showAdd(scope.$index,scope.row,3)">修改</button>
                                <button
                                class="tablebtn_inner btnView"
                                @click="openDelete(scope.$index,scope.row,3)">删除</button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="btnbox">
                        <el-button class="formButton" type="primary" @click="AddProj">添加工程文件</el-button>
                        <el-button class="formButton" type="primary" @click="closePoper1">确定</el-button>
                    </div >
                    <div class="innerAdd" v-if="isAdd">
                        <div class="addone" style="height: 20%;display:flex;align-items:center;">
                            <div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item1.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model="groupList2.item1.value"  placeholder="请输入内容"></el-input>
                            </div>
                            <div class="input_group">
                                <label  class="input_label" for="select">{{groupList2.item2.lable}}</label>
                                <el-select  id="select" class="inputInner" v-model="groupList2.item2.value" placeholder="请选择">
                                    <el-option
                                    v-for="item in groupList.item3.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="input_group">
                                <label  class="input_label" for="select">{{groupList2.item3.lable}}</label>
                                <el-select  id="select" class="inputInner" v-model="groupList2.item3.value" placeholder="请选择">
                                    <el-option
                                    v-for="item in AllClass.AllMaterialType"
                                    :key="item.id"
                                    :label="item.materialName"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="input_group" style="align-items: flex-end;width:60%;">
                                <button @click="editGeo" class="formButton" style="max-width:150px;height:30px" v-if="isNewAdd">编辑工程文件</button>
                                <button @click="open" class="formButton" style="height:65%" v-else>添加工程文件</button>
                            </div>
                            </div>
                        <div class="addtwo" v-if="isNewAdd" style="height:40%;display:flex;flex-direction:row;flex-wrap:wrap">
                            <div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item4.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList2.item4.value'  placeholder="请输入内容"></el-input>
                            </div>
                            <div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item5.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList2.item5.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item6.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList2.item6.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item7.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList2.item7.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item8.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList2.item8.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item9.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList2.item9.value'  placeholder="请输入内容"></el-input>
                            </div>
                            <div style="width:20%;height:25%;display:flex;justify-content:flex-end;align-items:flex-end;">
                                <button @click="openAddGeo" class="formButton" style="max-width:150px;height:65%">录入下条</button>
                            </div>
                            <div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item10.lable}}</label>
                                <el-input  id="input" class="inputInner"  v-model='groupList2.item10.value'  placeholder="请输入内容"></el-input>
                            </div>
                            <div class="input_group">
                                <label  class="input_label" for="input">{{groupList2.item11.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList2.item11.value'  placeholder="请输入内容"></el-input>
                            </div>
                            <div style="width:20%;height: 25%;display:flex;justify-content:flex-end;align-items:flex-end;">
                                <button @click="endGeo" class="formButton" style="max-width:150px;height:65%">结束录入</button>
                            </div>
                        </div>
                        <div v-if="isNewAdd" style="height:38%;margin-top:2%;">
                                <el-table
                                    :stripe='true'
                                    ref='multipleTable'
                                    :data="tableData_geotextile"
                                    height="100%"
                                    style="width: 100%;">
                                    <el-table-column
                                        prop="geotextile_name"
                                        label="名称"
                                        align="center">
                                        <!-- <template slot-scope="scope">
                                            <el-input class="innerInput" type="text" v-model="tableData_geotextile[scope.$index].geotextile_name"></el-input>
                                        </template> -->
                                    </el-table-column>
                                    <el-table-column
                                        prop="geotextile_startpile"
                                        label="起始桩号"
                                        align="center">
                                        <template slot-scope="scope">
                                            <el-input class="innerInput" type="text" v-model="tableData_geotextile[scope.$index].geotextile_startpile"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="geotextile_layersnumber"
                                        label="所在层数"
                                        align="center">
                                        <template slot-scope="scope">
                                            <el-input class="innerInput" type="text" v-model="tableData_geotextile[scope.$index].geotextile_layersnumber"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="option"
                                        align="center"
                                        label="操作">
                                        <template slot-scope="scope">
                                            <button
                                            class="tablebtn_inner btnView"
                                            @click="openAmend(scope.$index,scope.row,4)">修改</button>
                                            <button
                                            class="tablebtn_inner btnView"
                                            @click="openDelete(scope.$index,scope.row,4)">删除</button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane class="innnerTab" label="轴线文件" name="轴线文件">
                    <el-table
                    :stripe='true'
                        :data="tableData_axis"
                        height="100%"
                        style="width: 100%;">
                        <el-table-column
                            prop="axis_name"
                            label="轴线名称">
                            <template slot-scope="scope">
                                <el-input class="innerInput" type="text" v-model="tableData_axis[scope.$index].axis_name"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="axis_startpile"
                            label="起始桩号">
                            <template slot-scope="scope">
                                <el-input class="innerInput" type="text" v-model="tableData_axis[scope.$index].axis_startpile"></el-input>
                            </template>
                        </el-table-column>                      
                        <el-table-column
                            prop="updatetime"
                            label="最新修改时间">
                        </el-table-column>
                        <el-table-column
                            prop="option"
                            label="操作">
                            <template slot-scope="scope">
                                <button
                                class="tablebtn_inner btnView"
                                @click="showAdd(scope.$index,scope.row,2)">修改</button>
                                <button
                                class="tablebtn_inner btnView"
                                @click="openDelete(scope.$index,scope.row,2)">删除</button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="btnbox">
                        <el-button class="formButton" type="primary" @click="AddProj">添加轴线文件</el-button>
                        <el-button class="formButton" type="primary" @click="closePoper1">确定</el-button>
                    </div>
                    <div class="innerAdd" v-if="isAdd">
                            <!-- <div class="input_group" v-for="(item,key) in groupList3" :key='key'>
                                <label  class="input_label" for="input">{{item.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model="item.value"  placeholder="请输入内容"></el-input>
                            </div> -->

                            <div class="addtwo"  style="height:40%;display:flex;flex-direction:row;flex-wrap:wrap">
                            <div class="input_group">
                                <label  class="input_label" for="input">{{groupList3.item1.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList3.item1.value'  placeholder="请输入内容"></el-input>
                            </div>
                            <div class="input_group">
                                <label  class="input_label" for="input">{{groupList3.item2.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList3.item2.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList3.item3.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList3.item3.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList3.item4.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList3.item4.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList3.item5.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList3.item5.value'  placeholder="请输入内容"></el-input>
                            </div><div class="input_group">
                                <label  class="input_label" for="input">{{groupList3.item6.lable}}</label>
                                <el-input  id="input" class="inputInner" v-model='groupList3.item6.value'  placeholder="请输入内容"></el-input>
                            </div>
                            <div style="width:20%;height: 25%;display:flex;justify-content:flex-end;align-items:flex-end;">
                                <button @click="editAxis" class="formButton" style="width:150px;height:30px" v-if='isNewAdd'>修改</button>
                                <button @click="openAddAxis" class="formButton" style="width:150px;height:30px" v-else>添加</button>
                            </div>
                        </div>
                        <div  style="height:53%;margin-top:2%;">
                                <el-table
                                    :stripe='true'
                                    ref='multipleTable'
                                    :data="tableData_axis"
                                    height="100%"
                                     style="width: 100%;">
                                    <el-table-column
                                        prop="axis_name"
                                        label="名称"
                                        align="center">
                                    </el-table-column>
                                    <el-table-column
                                        prop="axis_startpile"
                                        label="起始桩号"
                                        align="center">
                                        <template slot-scope="scope">
                                            <el-input class="innerInput" type="text" v-model="tableData_axis[scope.$index].axis_startpile"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="updatetime"
                                        label="修改时间"
                                        align="center">
                                        <template slot-scope="scope">
                                            <el-input class="innerInput" type="text" v-model="tableData_axis[scope.$index].updatetime"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="option"
                                        align="center"
                                        label="操作">
                                        <template slot-scope="scope">
                                            <button
                                            class="tablebtn_inner btnView"
                                            @click="openAmend(scope.$index,scope.row,2)">修改</button>
                                            <button
                                            class="tablebtn_inner btnView"
                                            @click="openDelete(scope.$index,scope.row,2)">删除</button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="innerPoper2" ></div>
        <div class="innerPoper3"></div>
    </div>
</template>

<script>
// import css from '@/css/form.css'
// import css from '@/css/enter.css'
import API from '@/api/material'
import moment from 'moment'

export default {
    name:'mission',
    data(){
        return{
            radio:null,
            innerPoper1:false,
            activeName:'工程文件',
            itemKey:false,
            value:'',
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择任务区域',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
       
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择船舶',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
     
                },
                item3:{
                    isShow:false,
                    selectOrinput:false, //1 select 0 input
                    lable:'选择文件',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
        
                },
                item4:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'结束时间',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item5:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'单位',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                length:2
            },
            groupList2:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'工程文件名称',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
       
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择轴线',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
     
                },
                item3:{
                    isShow:false,
                    selectOrinput:false, //1 select 0 input
                    lable:'排体类型',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
        
                },
                item4:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'偏移量',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item5:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'生成排体数量',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                item6:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'排体宽度',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                item7:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'搭接宽度',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                item8:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'轴线左侧长度',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                item9:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'轴线右侧长度',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                item10:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'起始桩号',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                item11:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'排体所在层数',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                length:11
            },
            groupList3:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'轴线名称',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
       
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'起始桩号',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
     
                },
                item3:{
                    isShow:false,
                    selectOrinput:false, //1 select 0 input
                    lable:'起始坐标x',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
        
                },
                item4:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'起始坐标y',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item5:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'方向坐标x',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                item6:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'方向坐标y',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                length:6
            },
            boxBottom:{
                isBoxBottom:false,
                 input:'',
                 label:'备注'
                
            },
            tableData: [],
            tableData_axis:[],
            tableData_proj:[],
            tableData_proj_byid:[],
            tableData_geotextile:[],
            AllClass:this.$store.state.AllClass,
            tenderProjectId:null,
            tenderProjectIdNew:null,
            tenderAxis_id:null,
            isAdd:false,
            geoParma:{action:'getall_project_id'},
            isNewAdd:true
        }
    },
    methods:{
        // 1:任务发送 2：工程文件 3；轴文件 4：根据工程文件id获取排后，工程文件内排
        addAxis(){
            let param = {
                action:'add_axis',
                axis_name:this.groupList3.item1.value,
                axis_startpile_code:this.groupList3.item2.value,
            };
            let param2={
                action:'add_gps_start',
                GPS_ForeignKey:1,
                GPS_Type:'Axis_Startpoint',
                GPS_World_Positionx_START:this.groupList3.item3.value,
                GPS_World_Positiony_START:this.groupList3.item4.value,
            }
            let param3={
                action:'add_gps_end',
                GPS_ForeignKey:1,
                GPS_Type:'Axis_Endpoint',
                GPS_World_Positionx_END:this.groupList3.item3.value,
                GPS_World_Positionx_END:this.groupList3.item4.value,
            }
           return new Promise((resolve,reject)=>{
                            API.getAllAxis(param).then((res)=>{
                                // console.log(res.message.obj);
                                param2.GPS_ForeignKey = param3.GPS_ForeignKey =res.message.obj.axis_id;
                                API.getAllAxis(param2).catch(err=>{console.log(err);resolve(0)})
                                API.getAllAxis(param3).catch(err=>{console.log(err);resolve(0)})
                                resolve(res)
                            }).catch((err)=>{
                                resolve(0)
                            })
                    }).catch(err=>{
                        resolve(0)
                    }) 
            
           

        },
        openAddAxis(){
            this.$confirm('是否确认添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.addAxis().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '添加成功',
                        type: 'success'
                        });
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '添加失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
            })
            .catch(() => {
            this.$message({
                type: 'info',
                message: '已取消添加'
            });          
            });
        },
        AddProj(){
            this.isAdd = true;
            this.isNewAdd = false;
        },
        showAdd(index,row,num){
            // action=getall_project_id&project_project_id=1
            // this.tableData_geotextile=[];
                this.isAdd = true;
                this.isNewAdd = true;
            if(num == 3){
                
                let list = this.tableData_proj
                    this.geoParma.project_project_id = list[index].project_id,
                API.getGeotextile(this.geoParma).then((res)=>{
                    this.tableData_geotextile = this.formatTableListGeotextile(res.message.obj||{});
                }).catch((err)=>{
                    console.log(err);
                })
                    this.tenderAxis_id = row.axis_id;
                    this.groupList2.item1.value = list[index].project_name;
                    this.groupList2.item2.value = list[index].axis_id;
                    this.groupList2.item3.value = list[index].materialtype_id;
            }else if(num==2){
                let list = this.tableData_axis;
                let param = {
                    action:'getall_gps_key_type',
                    GPS_ForeignKey:list[index].axis_id,
                    GPS_Type:'Axis_Startpoint'
                }
                let param2 = {
                    action:'getall_gps_key_type',
                    GPS_ForeignKey:list[index].axis_id,
                    GPS_Type:'Axis_Endpoint'
                }
                let tempList1;
                let tempList2;
                new Promise((resolve,reject)=>{
                        API.getAllAxis(param).then((res)=>{
            
                            tempList1=res.message.obj[0]
                        }).then(()=>{
                                API.getAllAxis(param2).then((res)=>{
                                    tempList2=res.message.obj[0]
                                resolve()
                            }).catch((err)=>{
                                console.log(err);
                            })
                        }).catch((err)=>{
                            console.log(err);
                        })
                }).then(()=>{
                    this.tenderAxis_id = row.axis_id;
                    this.groupList3.item1.value = list[index].axis_name;
                    this.groupList3.item2.value = list[index].axis_startpile;
                    this.groupList3.item3.value = tempList1.gps_World_Positionx;
                    this.groupList3.item4.value = tempList1.gps_World_Positiony;
                    this.groupList3.item5.value = tempList2.gps_World_Positionx;
                    this.groupList3.item6.value = tempList2.gps_World_Positiony;
                })
            }
           
        },
        editGeo(){
            this.$confirm('是否确认修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                 new Promise((resolve,reject)=>{
                    API.getProjectEditServlet({
                    action:'update',
                    project_id:this.geoParma.project_project_id,
                    materialtype_id: this.groupList2.item3.value ,
                    project_name: this.groupList2.item1.value ,
                    // boat_id: this.groupList2.item2.value ,
                    axis_id: this.tenderAxis_id,
                }).then((res)=>{
                    resolve(res);
                }).catch(err=>{
                    resolve(0);
                    console.log(err);
                });
                }).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '修改成功',
                        type: 'success'
                        });
                        this.synchrodata()
                    }else{
                        this.$message({
                        message: '修改失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }) 
               
                
            }).catch(err=>{
                console.log(err);
            })
        },
        editAxis(){
            this.$confirm('是否确认修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                let param = {
                    action:'update',
                    axis_name:this.groupList3.item1.value,
                    axis_startpile_code:this.groupList3.item2.value,
                };
                let param2={
                    action:'update_gps',
                    GPS_ForeignKey:1,
                    GPS_Type:'Axis_Startpoint',
                    GPS_World_Positionx_START:this.groupList3.item3.value,
                    GPS_World_Positiony_START:this.groupList3.item4.value,
                }
                let param3={
                    action:'update_gps',
                    GPS_ForeignKey:1,
                    GPS_Type:'Axis_Endpoint',
                    GPS_World_Positionx_END:this.groupList3.item3.value,
                    GPS_World_Positionx_END:this.groupList3.item4.value,
                }
                 new Promise((resolve,reject)=>{
                    API.getAllAxis(param).then((res)=>{
                                // console.log(res.message.obj);
                                param2.GPS_ForeignKey = param3.GPS_ForeignKey =res.message.obj.axis_id;
                                API.getAllAxis(param2).catch(err=>{console.log(err);resolve(0)})
                                API.getAllAxis(param3).catch(err=>{console.log(err);resolve(0)})
                                resolve(1)
                            }).catch((err)=>{
                                resolve(0)
                            })
                }).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '修改成功',
                        type: 'success'
                        });
                        this.synchrodata()
                    }else{
                        this.$message({
                        message: '修改失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }) 
               
                
            }).catch(err=>{
                console.log(err);
            })
        },
        openAddGeo() {
            this.$confirm('是否确认添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.addGeoByProj().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '添加成功',
                        type: 'success'
                        });
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '添加失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
            })
            .catch(() => {
            this.$message({
                type: 'info',
                message: '已取消添加'
            });          
            });
        },
        addGeoByProj(){
            // action=add&createNum=20&geotextile_width=13&geotextile_jointwidth=5&geotextile_layersnumber=1&geotextile_offset=9&geotextile_startpile=K&project_project_id=1&axis_startpile_code=K_0&geotextile_leftaxis_distance=10&geotextile_rightaxis_distance=10
            let param = {
                action:'add',
                project_project_id:this.geoParma.project_project_id,
                geotextile_offset:this.groupList2.item4.value,
                createNum:this.groupList2.item5.value,
                geotextile_width:this.groupList2.item6.value,
                geotextile_jointwidth:this.groupList2.item7.value,
                geotextile_leftaxis_distance:this.groupList2.item8.value,
                geotextile_rightaxis_distance:this.groupList2.item9.value,
                geotextile_startpile: this.groupList2.item10.value,
                // geotextile_startpile: "k",
                geotextile_layersnumber:this.groupList2.item11.value,
            }
            // API.getGeotextile(param).then((res)=>{
            //     this.tableData_geotextile = this.formatTableListGeotextile(res.message.obj||{});
            //     this.synchrodata();
            // }).catch((err)=>{
            //     console.log(err);

            // })
            return new Promise((resolve,reject)=>{
                    API.getGeotextile(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
        },
        addProjMethod(){
            
        },
        endGeo(){
            this.closePoper2();
        },
        getCurrentRow(val){
            this.tenderProjectId = val.project_id;
            this.tenderAxis_id = val.axis_id;
            console.log('this.tenderAxis_id',this.tenderAxis_id);
        },
        closePoper1(){
            this.innerPoper1 = false
        },
        closePoper2(){
            if(!this.isAdd){
                this.innerPoper1 = false;
                this.tenderProjectId = null;
                this.radio = null;
            }else{
                this.isAdd = false;
                for(var i = 0;i< this.groupList2.length;i++){
                    this.groupList2[`item${i+1}`].value = ''
                }

            }
            
        },
        closePoper3(){
                this.isNewAdd = false;
                for(var i = 0;i< this.groupList3.length;i++){
                    this.groupList3[`item${i+1}`].value = ''
                }
            
        },
        editFile(){
            this.innerPoper1 = true
        },
        cellClick(item){
            API.getPlannedProgressServlet({action:'getall_boat_id',boat_id:item.value||''}).then((res)=>{
                this.tableData = this.formatTableList(res.message.obj||{});
            })
        },
        timestamp(date){
            return moment(date).format("x");
        },
        amend(index,row,num){
            if(num ==1){
                let list = this.tableData
                let param = {
                    action:'update',
                    id:list[index].id,
                    boat_id:list[index].boat_id,
                    engineerregion_id:list[index].engineerregion_id,
                    axis_id:list[index].axis_id,
                    projectfile_id:list[index].projectfile_id,
                }
                return new Promise((resolve,reject)=>{
                    API.getTaskSendingServlet(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }else if(num ==2){
                let list = this.tableData_axis
                let param = {
                    action:'update',
                    axis_id:list[index].axis_id,
                    axis_name:list[index].axis_name,
                    axis_startpile_code:list[index].axis_startpile,
                }
                return new Promise((resolve,reject)=>{
                    API.getAllAxis(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }else if(num ==3){
                let list = this.tableData_proj
                let param = {
                    action:'update',
                    project_id:parseInt(list[index].project_id),
                    project_name:list[index].project_name,
                    axis_id:list[index].axis_id,
                    materialtype_id:parseInt(list[index].materialtype_id),
                }
                return new Promise((resolve,reject)=>{
                    API.getProjectEditServlet(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }else if(num ==4){
                let list = this.tableData_geotextile
                let param = {
                    action:'update',
                    geotextile_id:list[index].geotextile_id,
                    // geotextile_name:list[i].geotextile_name,
                    geotextile_layersnumber:list[index].geotextile_layersnumber,
                    geotextile_startpile:list[index].geotextile_startpile,
                }
                return new Promise((resolve,reject)=>{
                    API.getGeotextile(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }
            
        },
        delete(index,row,num){
            // &id=1&geotextileName=太古第er排&resetTime=2023-12-22 10:11:11&reason=不规范2&check=未完成&note=
            if(num ==1){
                let list = this.tableData
                let param = {
                    action:'delete',
                    id:list[index].id,
                }
                return new Promise((resolve,reject)=>{
                    API.getTaskSendingServlet(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }else if(num ==2){
                let list = this.tableData_axis
                let param = {
                    action:'delete',
                    axis_id:list[index].axis_id,
                }
                return new Promise((resolve,reject)=>{
                    API.getAllAxis(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }else if(num ==3){
                
                let list = this.tableData_proj
                let param = {
                    action:'delete',
                    project_id:list[index].project_id,
                }
                return new Promise((resolve,reject)=>{
                    API.getProjectEditServlet(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }else if(num ==4){
                let list = this.tableData_geotextile
                let param = {
                    action:'delete',
                    geotextile_id:list[index].geotextile_id,
                }
                return new Promise((resolve,reject)=>{
                    API.getGeotextile(param).then((res)=>{
                        resolve(res)
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                }) 
            }
           
        },
        openDelete(index,row,num) {
            this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.delete(index,row,num).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '删除成功',
                        type: 'success'
                        });
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '删除失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }).catch(err=>{
                    console.log('1',err);
                })
            }).catch(err=>{
                console.log('2',err);
            })
        },
        addMethod(){
            let list = this.groupList2
                let tmpValue ={
                    action:'add',
                    project_name:list.item1.value,
                    axis_id:list.item2.value,
                    materialtype_id:list.item3.value,
                };
             return new Promise((resolve,reject)=>{
                    API.getProjectEditServlet(tmpValue).then(res=>{
                        resolve(res);
                    }).then(()=>{
                        // this.synchrodata();
                        API.getProjectEditServlet({action:'getall'}).then((res)=>{
                        this.geoParma.project_project_id =  res.message.obj[res.message.obj.length-1].project_id;
                        this.synchrodata();
                        }).catch(err=>{
                            console.log(err);
                        });
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                })  
        },
        open() {
            this.$confirm('是否确认添加, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.addMethod().then((message)=>{
                        if(message != 0){
                            this.$message({
                            message: '添加成功',
                            type: 'success'
                            });
                            this.isNewAdd = true;
                            this.tableData_geotextile = [];
                        }else{
                            this.$message({
                            message: '添加失败，请稍后再试',
                            type: 'error'
                            });
                        }
                    })
                })
                .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消添加'
                });          
                });
                
                
           
        },
        openAmend(index,row,num) {
            this.$confirm('是否确认修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.amend(index,row,num).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '修改成功',
                        type: 'success'
                        });
                        this.synchrodata()
                    }else{
                        this.$message({
                        message: '修改失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }).catch(err=>{
                    console.log('1',err);
                })
            }).catch(err=>{
                console.log('2',err);
            })
        },    
        send() {
            let list = this.groupList
                let tmpValue ={
                    action:'add',
                    boat_id:list.item2.value,
                    engineerregion_id:list.item1.value,
                    axis_id:this.tenderAxis_id,
                    projectfile_id:this.tenderProjectId,
                    recivestate:'未接收',
                    completion_status:'未完成',
                };
             return new Promise((resolve,reject)=>{
                    API.getTaskSendingServlet(tmpValue).then(res=>{
                        resolve(res);
                    }).then(()=>{
                        this.synchrodata();
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                })  
        },
        openSend(index,row,num) {
            this.$confirm('是否确认添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.send(index,row,num).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '添加成功',
                        type: 'success'
                        });
                    }else{
                        this.$message({
                        message: '添加失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }).catch(err=>{
                    console.log('1',err);
                })
            }).catch(err=>{
                console.log('2',err);
            })
        },   
        synchrodata(){  
                    this.getGroupList();
                    this.getTableList();
        },
        submit(){
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.openSend();
            } 
        },
        verifyMainLabel() {
            let result = true;
           for(var i = 1;i <= 2;i++){
                if(`${this.groupList[`item${i}`].value}` == '' ||this.groupList[`item${i}`].value == null){
                    result = false;
                }
            }
            if(this.tenderProjectId == null){result =  false}
            return result
        },
        formattingDate(date) {
            return date?moment(date).format("YYYY-MM-DD HH:mm:ss"):'暂无';
            },
        formatList(lists){
        let tmpList = [];
        let list = lists?lists:[];
        for(var i = 0; i <list.length;i++){
            tmpList.push({
                value:list[i].id,
                label:list[i].engineering_region_name,
            })
        }
        return tmpList

        },
        formatList2(lists){
        let tmpList = [];
        let list = lists?lists:[];
        for(var i = 0; i <list.length;i++){
            tmpList.push({
                value:list[i].boat_id,
                label:list[i].boat_id,
            })
        }
        return tmpList

        },
        formatList3(lists){
        let tmpList = [];
        let list = lists?lists:[];
        for(var i = 0; i <list.length;i++){
            tmpList.push({
                value:list[i].axis_id,
                label:list[i].axis_name,
                axis_startpile:list[i].axis_startpile,
            })
        }
        return tmpList

        },
        formatList4(lists){
        let tmpList = [];
        let list = lists?lists:[];
        for(var i = 0; i <list.length;i++){
            tmpList.push({
                value:list[i].project_id,
                label:list[i].project_name,
            })
        }
        return tmpList

        },
        getGroupList(){
            API.getEngineerRegion({action:'getall'}).then((res)=>{
                this.groupList.item1.selectOptions = this.formatList(res.message.obj);
                
            }).catch(err=>{
                console.log(err);
            });
            API.getAllShip({action:'getall'}).then((res)=>{
                this.groupList.item2.selectOptions = this.formatList2(res.message.obj);
            }).catch(err=>{
                console.log(err);
            });
            API.getAllAxis({action:'getall'}).then((res)=>{
                this.groupList.item3.selectOptions = this.formatList3(res.message.obj);
                this.tableData_axis = this.formatTableListAxis(res.message.obj||{});
            }).catch(err=>{
                console.log(err);
            });
            API.getProjectEditServlet({action:'getall'}).then((res)=>{
                this.groupList.item4.selectOptions = this.formatList4(res.message.obj);
                this.tableData_proj = this.formatTableList(res.message.obj);
            }).catch(err=>{
                console.log(err);
            });
        },
        formatTableList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    axis_id:list[i].axis_axis_id,//轴id
                    boat_boat_id:list[i].boat_boat_id,//船id
                    engineeringproject_engineeringproject_ID:list[i].engineeringproject_engineeringproject_ID,//
                    ismakeup:list[i].ismakeup,//
                    materialtype_id:list[i].materialtype_id,//材料类型
                    project_id:list[i].project_id,//主键
                    project_lrmethod:list[i].project_lrmethod,//
                    project_name:list[i].project_name,//项目名称
                    updatetime:this.formattingDate(list[i].updatetime),//更新时间
                })
            }
            return tmpList
        },
        formatTableListTask(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    axis_id:list[i].axis_id,//轴id
                    boat_id:list[i].boat_id,
                    completion_status:list[i].completion_status,
                    engineerregion_id:list[i].engineerregion_id,
                    id:list[i].id,
                    projectfile_id:list[i].projectfile_id,
                    recivestate:list[i].recivestate,
                    sendtime:this.formattingDate(list[i].sendtime),
                })
            }
            return tmpList
        },
        formatTableListAxis(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    axis_id:list[i].axis_id,//轴id
                    axis_name:list[i].axis_name,
                    axis_startpile:list[i].axis_startpile_code,
                    updatetime:this.formattingDate(list[i].updatetime),
                })
            }
            return tmpList
        },
        formatTableListGeotextile(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    geotextile_id:list[i].geotextile_id,//轴id
                    geotextile_name:list[i].geotextile_name,
                    geotextile_layersnumber:list[i].geotextile_layersnumber,
                    geotextile_startpile:list[i].geotextile_startpile,
                });
            }
            return tmpList
        },
        getTableList(){
            // action=getallboatid&boat_id=交建10号
            let params = {
                action:'getall',
            }
            API.getTaskSendingServlet(params).then((res)=>{
                this.tableData = this.formatTableListTask(res.message.obj||{});
            }).catch(err=>{
                console.log(err);
            });
            API.getGeotextile(Object.keys(this.geoParma).length==2?this.geoParma:params).then((res)=>{
                this.tableData_geotextile = this.formatTableListGeotextile(res.message.obj||{});
            }).catch((err)=>{
                console.log(err);
            })
        }
    },
    created(){
            this.synchrodata();
            
  },
  watch:{
    activeName(){
        this.radio = this.value = this.tenderProjectId =this.tenderAxis_id = null;
        this.isAdd = false
    },
    tenderProjectId(a){
        console.log('tenderProjectId has changed',a);
    },
    tenderProjectIdNew(a){
        console.log('tenderProjectIdNew has changed',a);
    },
    
}

}
</script>

<style scoped>
/* .mission{
    height: 100%;
    width: 90%;
    margin: 0 auto;
} */
.buttonBox{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;

    
}
.buttonBox button:last-child{
    margin-left: 5%;
}
.buttonBox button{
    height: 45%;
    width: 25%;
}

.innerPoper{
    height: 100%;
    width: 100%;
    background-color: var(--subject--tag--body);
    position: absolute;
    background-color: var(--subject--tag--body);
    top: 0;
    left: 0;
    /* top: calc(50% - 250px); */
    /* left: calc(50% - 350px); */
    box-shadow: 20px 20px 40px rgba(0, 0, 0, 0.502);
    display: flex;
    align-items: center;
    flex-direction: column;
}

.innnerTabs{
    width: 90%;
    height: 88%;
    display: flex;
    flex-direction: column;
     justify-content: center;
}
.innnerTab{
    width: 100%;
    height: 90%;
}
.btnbox{
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: flex-end;
}
.innerAdd{
    height: 100%;
    width: 100%;position: absolute;
    top: 0;
    left: 0;
    background-color: var(--subject--tag--body);
    box-shadow: 20px 20px 40px rgba(0, 0, 0, 0.502);
    z-index: 9999;
}
</style>>














